/*eslint-disable */

import Vue from 'vue'
import moment from 'moment';

Vue.filter('dateformat', (arg) => {
  return moment(arg).locale('en').format('MMM DD, YYYY')
})
Vue.filter('timeformat', (arg) => {
  return moment(arg).locale('en').format('h:mm:ss a')
})
Vue.filter('chattimeformat', (arg) => {
  return moment(arg).locale('en').format('h:mm a')
})
Vue.filter('chatdateformat', (arg) => {
  return moment(arg).locale('en').format('Do MMMM')
})
Vue.filter('chatfulldateformat', (arg) => {
  return moment(arg).locale('en').format('MMM DD, YYYY')
})
Vue.filter('UtcDateFormat', (arg) => {
  return moment(arg).locale('en').utc().format('MMMM DD YYYY')
})
Vue.filter('UtcTimeFormat', (arg) => {
  return moment(arg).locale('en').utc().format('h:mm:ss a')
})
Vue.filter('LocalDateFormat', (arg) => {
  return moment(arg).locale('en').local().format('MMM DD, YYYY')
})
Vue.filter('LocalTimeFormat', (arg) => {
  return moment(arg).locale('en').local().format('h:mm a')
})